const env = {
  apiUrl: process.env.REACT_APP_API_URL as string,
  // Os relatórios batem no PHP do Analytics, que fica fora do api/index.php
  analyticsUrl: process.env.REACT_APP_ANALYTICS_URL as string,
  googleMapsKey: process.env.REACT_APP_GOOGLE_MAPS_KEY as string,
};

export default env;
